import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyRobotsMeta } from "@/lib/seo";

export function useRobotsMeta() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    applyRobotsMeta(pathname, hash);
  }, [pathname, hash]);
}
